export default __webpack_public_path__ + "static/media/gallery-1.cba16fd6.jpg";